export default __webpack_public_path__ + "static/media/Flaticon.ff4db9d6.eot";